import { Spinner } from 'react-bootstrap';
import { MessagePageComponent } from '../../message-page/message-page.component';
import { FilterSelectionReceptorComponentProps } from '../interfaces/filterable-component-props.interface';
import { useFilterReadyContext } from './filter.provider';

export const FilterProvider = ({
  children,
}: FilterSelectionReceptorComponentProps) => {
  const ready = useFilterReadyContext();
  if (ready) {
    return <>{children}</>;
  } else {
    return (
      <MessagePageComponent>
        <div>
          <Spinner size="sm" /> Loading... Please, wait.
        </div>
      </MessagePageComponent>
    );
  }
};
